/**
 * ═══════════════════════════════════════════════════════════════════════════════════════
 * TK-32 mục B (22/10/2026) — trang VẤN ĐỀ `/van-de`, theo `_BUS/thiet_ke/TK-31_32/TrungTam.dc.html` (bản 2):
 * 4 ô đếm (Khẩn · Mất kết nối · Cảnh báo · Chưa đọc) + khung `HopVanDe` phạm vi hệ thống + cột "Thông báo".
 *
 * TK-32 B (dev_app 22/10): dải vàng đã bỏ; chuông mở ngăn kéo cùng khung `HopVanDe`; Tổng quan dùng cùng khung.
 * Tuỳ chọn thông báo: `lib/thongbao.ts` (một chỗ đọc/ghi; `PopupCanhBao` đọc). Đã tự quyết: popup Khẩn LUÔN bật
 * (không cho tắt tiếng mức 1 từ một ô đánh dấu); bỏ ô "Âm thanh" vì chưa có âm thanh nào — ô không làm gì là khai sai.
 * ═══════════════════════════════════════════════════════════════════════════════════════
 */
import { useEffect, useMemo, useState } from 'react';
import { HopVanDe } from '../components/HopVanDe';
import { useAlarms } from '../lib/queries';
import { laMatKetNoi, phanMuc } from '../lib/canhbao';

import { docThongBao, ghiThongBao, type TuyChonThongBao } from '../lib/thongbao';

export default function VanDePage() {
  useEffect(() => { document.title = 'Vấn đề — SDKD Chiếu sáng'; }, []);
  const mo = useAlarms();
  const dem = useMemo(() => {
    let khan = 0, canh = 0, mat = 0;
    for (const a of mo.data ?? []) { const pm = phanMuc(a.code, a.mucDo); if (laMatKetNoi(pm.ma || a.code)) mat++; else if (pm.mucDo === 1) khan++; else canh++; }
    return { khan, canh, mat };
  }, [mo.data]);
  const [tb, setTb] = useState<TuyChonThongBao>(docThongBao);
  const doiMat = () => { const m = { ...tb, popupMat: !tb.popupMat }; setTb(m); ghiThongBao(m); };

  return (
    <div className="space-y-4" data-o="trang-van-de">
      <h1 className="m-0 text-xl font-semibold text-chu-1">Vấn đề</h1>
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4" data-o="o-dem">
        <ODem so={dem.khan} ten="Khẩn" lop="text-nguy" />
        <ODem so={dem.mat} ten="Mất kết nối" lop="text-chu-2" />
        <ODem so={dem.canh} ten="Cảnh báo" lop="text-canh" />
        <ODem so={null} ten="Chưa đọc" lop="text-chu-3" />
      </div>
      <div className="grid gap-4 xl:grid-cols-[minmax(0,1fr)_300px]">
        <HopVanDe pham="he-thong" tieuDe="Tất cả" />
        <section className="card flex flex-col gap-1 p-4" data-o="thong-bao">
          <h2 className="m-0 mb-1 text-base font-semibold text-chu-1">Thông báo</h2>
          <label className="flex min-h-[44px] items-center gap-3 text-sm text-chu-2" title="Luôn bật"><input type="checkbox" checked disabled className="h-[18px] w-[18px] accent-nhan" />Popup khi Khẩn</label>
          <label className="flex min-h-[44px] items-center gap-3 text-sm text-chu-1"><input type="checkbox" checked={tb.popupMat} onChange={doiMat} data-o="tb-popup-mat" className="h-[18px] w-[18px] accent-nhan" />Popup cả Mất kết nối</label>
          <p className="m-0 text-xs text-chu-3">Số trên chuông = Khẩn + Mất kết nối</p>
        </section>
      </div>
    </div>
  );
}

function ODem({ so, ten, lop }: { so: number | null; ten: string; lop: string }) {
  return (
    <div className="card flex items-baseline gap-2.5 px-4 py-3.5">
      <b className={`text-2xl tabular-nums ${lop}`}>{so === null ? '—' : so}</b>
      <span className="text-sm text-chu-2">{ten}</span>
    </div>
  );
}
